import { TextSortBy } from "nystem-components";

const TextareaSortBy = (props) => <TextSortBy {...props} />;
export default TextareaSortBy;
